import types from './types';

export function selectLocation(id) {
  return {
    type: types.SELECT_LOCATION,
    payload: {
      id,
    },
  };
}

export function deselectLocation(id) {
  return {
    type: types.DESELECT_LOCATION,
    payload: {
      id,
    },
  };
}

export function flipSelectedLocations() {
  return {
    type: types.FLIP_SELECTED_LOCATIONS,
  };
}

export function setPathSuggestions(pathSuggestions) {
  return {
    type: types.SET_PATH_SUGGESTIONS,
    payload: {
      pathSuggestions,
    },
  };
}

export function selectPathSuggestion(pathSuggestion) {
  return {
    type: types.SELECT_PATH_SUGGESTION,
    payload: {
      pathSuggestion,
    },
  };
}

export function setCreatedSegmentId(id) {
  return {
    type: types.SET_CREATED_SEGMENT_ID,
    payload: {
      id,
    },
  };
}

export function clearCreateSegment() {
  return {
    type: types.CLEAR_CREATE_SEGMENT,
  };
}

export function startCreateOppositeSegment() {
  return {
    type: types.START_CREATE_OPPOSITE_SEGMENT,
  };
}



// WEBPACK FOOTER //
// ./src/state/ducks/segmentCreation/actions.js